/* Fills the shell's scroll area so the board (not the page) owns scrolling:
   the header sits at the top and the board absorbs the rest, with its lanes
   scrolling internally. */
.screen {
	height: 100%;
	max-width: var(--screen-max);
	margin: 0 auto;
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.empty {
	color: var(--ink-muted);
	text-align: center;
	padding: var(--space-6) var(--space-4);
	margin: 0;
}

.retry {
	background: none;
	border: none;
	color: var(--accent-sage);
	cursor: pointer;
	font: inherit;
	padding: 0;
	text-decoration: underline;
}
